export default "__VITE_ASSET__d59e1f4f__"